<template>
  <div v-if="!loading" id="chart3" style="margin-bottom: 10px">
    <!-- Total requests chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Google maps API requests</h4>
    <p :style="{ color: primaryColor, display: 'inline-block' }">{{ userLabelComputed }}</p>
    <apex-chart type="bar" height="280" :options="chartOptionsTotal" :series="seriesTotal"
      :colors="colorsTotal"></apex-chart>

    <!-- Users chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Users</h4>
    <apex-chart type="bar" height="220" :options="chartOptionsUsers" :series="seriesUsers"
      :colors="colorsUsers"></apex-chart>

    <!-- Avg requests per user chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Avg requests per user</h4>
    <apex-chart type="line" height="220" :options="chartOptionsAvg" :series="seriesAvg"
      :colors="colorsAvg"></apex-chart>

    <!-- Signup - Total requests chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Google maps API requests (Signup)
    </h4>
    <apex-chart type="bar" height="280" :options="chartOptionsTotalSignup" :series="seriesTotalSignup"
      :colors="colorsTotalSignup"></apex-chart>

    <!-- Signup - Users chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Users (Signup)</h4>
    <apex-chart type="bar" height="220" :options="chartOptionsUsersSignup" :series="seriesUsersSignup"
      :colors="colorsUsersSignup"></apex-chart>

    <!-- Signup - Avg requests per user chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Avg requests per user (Signup)
    </h4>
    <apex-chart type="line" height="220" :options="chartOptionsAvgSignup" :series="seriesAvgSignup"
      :colors="colorsAvgSignup"></apex-chart>

    <!-- Logging - Total requests chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Google maps API requests
      (Logging)</h4>
    <apex-chart type="bar" height="280" :options="chartOptionsTotalLogging" :series="seriesTotalLogging"
      :colors="colorsTotalLogging"></apex-chart>

    <!-- Logging - Users chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Users (Logging)</h4>
    <apex-chart type="bar" height="220" :options="chartOptionsUsersLogging" :series="seriesUsersLogging"
      :colors="colorsUsersLogging"></apex-chart>

    <!-- Logging - Avg requests per user chart -->
    <h4 :style="{ color: primaryColor, display: 'inline-block', margin: '10px 12px' }">Avg requests per user (Logging)
    </h4>
    <apex-chart type="line" height="220" :options="chartOptionsAvgLogging" :series="seriesAvgLogging"
      :colors="colorsAvgLogging"></apex-chart>

    <Row>
      <Col :span="8">
      <p style="display: flex; justify-content: left; align-items: center">
        <PhArrowFatLeft style="cursor: pointer" size="32" @click="handlePrev" />
      </p>
      </Col>
      <Col :span="8">
      </Col>
      <Col :span="8" style="text-align: end">
      <p style="display: flex; justify-content: right; align-items: center">
        <PhArrowFatRight style="cursor: pointer" size="32" @click="handleNext" />
      </p>
      </Col>
    </Row>
  </div>

  <div v-if="loading" class="flex items-center justify-center py-28 md:py-32 lg:py-36">
    Loading...
  </div>
</template>

<script>
/* eslint-disable */
import { Row, Col } from 'ant-design-vue';
import { PhArrowFatLeft, PhArrowFatRight } from 'phosphor-vue';
import apiAxios from '@/services/apiAdminAxios'
export default {
  name: 'GoogleApiPlatformChart',
  components: {
    Row,
    Col,
    PhArrowFatLeft,
    PhArrowFatRight,
  },
  data() {
    return {
      loading: false,
      userLabel: '',
      primaryColor: '#278c64',

      // Regular series
      seriesTotal: [],
      seriesUsers: [],
      seriesAvg: [],

      // Signup series
      seriesTotalSignup: [],
      seriesUsersSignup: [],
      seriesAvgSignup: [],

      // Logging series
      seriesTotalLogging: [],
      seriesUsersLogging: [],
      seriesAvgLogging: [],

      // Chart options for regular
      chartOptionsTotal: {
        chart: { type: 'bar', height: 280 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        legend: { show: false },
        dataLabels: { enabled: true },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },
      chartOptionsUsers: {
        chart: { type: 'bar', height: 220 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        legend: { show: false },
        dataLabels: { enabled: true },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },
      chartOptionsAvg: {
        chart: { type: 'line', height: 220 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        stroke: { curve: 'smooth', colors: ['#278c64'] },
        dataLabels: { enabled: true, style: { colors: ['#278c64'] } },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },

      // Chart options for signup
      chartOptionsTotalSignup: {
        chart: { type: 'bar', height: 280 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        legend: { show: false },
        dataLabels: { enabled: true },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },
      chartOptionsUsersSignup: {
        chart: { type: 'bar', height: 220 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        legend: { show: false },
        dataLabels: { enabled: true },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },
      chartOptionsAvgSignup: {
        chart: { type: 'line', height: 220 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        stroke: { curve: 'smooth', colors: ['#278c64'] },
        dataLabels: { enabled: true, style: { colors: ['#278c64'] } },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },

      // Chart options for logging
      chartOptionsTotalLogging: {
        chart: { type: 'bar', height: 280 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        legend: { show: false },
        dataLabels: { enabled: true },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },
      chartOptionsUsersLogging: {
        chart: { type: 'bar', height: 220 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        legend: { show: false },
        dataLabels: { enabled: true },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },
      chartOptionsAvgLogging: {
        chart: { type: 'line', height: 220 },
        xaxis: { categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] },
        stroke: { curve: 'smooth', colors: ['#278c64'] },
        dataLabels: { enabled: true, style: { colors: ['#278c64'] } },
        fill: {
          opacity: 1,
          colors: ['#278c64', '#278c64'],
        },
      },

      // Color arrays - Regular
      colorsTotal: ['#278c64'],
      colorsUsers: ['#278c64'],
      colorsAvg: ['#278c64'],

      // Color arrays - Signup
      colorsTotalSignup: ['#278c64'],
      colorsUsersSignup: ['#278c64'],
      colorsAvgSignup: ['#278c64'],

      // Color arrays - Logging
      colorsTotalLogging: ['#278c64'],
      colorsUsersLogging: ['#278c64'],
      colorsAvgLogging: ['#278c64'],

      activeYear: 2026,
    };
  },
  methods: {
    async fetchYear(year) {
      this.loading = true;
      this.userLabel = `Year ${year}`;
      try {
        const from = `${year}-01-01`;
        const to = `${year}-12-30`;
        const url = `/admin/stats/google-maps-api-usage?from_year=${encodeURIComponent(from)}&to_year=${encodeURIComponent(to)}`;

        const res = await apiAxios.get(url);
        const payload = res.data;

        const monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        // Helper function to process data
        const processData = (dataKey, usersKey, avgKey) => {
          const totals = monthsFull.map(m => {
            const v = payload?.[dataKey]?.[m];
            return typeof v === 'number' ? v : Number(v) || 0;
          });
          const users = monthsFull.map(m => {
            const v = payload?.[usersKey]?.[m];
            return typeof v === 'number' ? v : Number(v) || 0;
          });
          const avg = monthsFull.map((m, i) => {
            const apiVal = payload?.[avgKey]?.[m];
            if (typeof apiVal === 'number') return Number(apiVal.toFixed(2));
            const u = users[i] || 0;
            return u ? Number((totals[i] / u).toFixed(2)) : 0;
          });
          return { totals, users, avg };
        };

        // Process regular data
        const regular = processData('data', 'users', 'avg_requests_per_user');
        this.seriesTotal = [{ name: 'Total requests', data: regular.totals }];
        this.seriesUsers = [{ name: 'Users', data: regular.users }];
        this.seriesAvg = [{ name: 'Avg requests per user', data: regular.avg }];

        // Process signup data
        const signup = processData('data_signup', 'users_signup', 'avg_requests_per_user_signup');
        this.seriesTotalSignup = [{ name: 'Total requests', data: signup.totals }];
        this.seriesUsersSignup = [{ name: 'Users', data: signup.users }];
        this.seriesAvgSignup = [{ name: 'Avg requests per user', data: signup.avg }];

        // Process logging data
        const logging = processData('data_logging', 'users_logging', 'avg_requests_per_user_logging');
        this.seriesTotalLogging = [{ name: 'Total requests', data: logging.totals }];
        this.seriesUsersLogging = [{ name: 'Users', data: logging.users }];
        this.seriesAvgLogging = [{ name: 'Avg requests per user', data: logging.avg }];

        // Update all chart x-axes
        [this.chartOptionsTotal, this.chartOptionsUsers, this.chartOptionsAvg,
        this.chartOptionsTotalSignup, this.chartOptionsUsersSignup, this.chartOptionsAvgSignup,
        this.chartOptionsTotalLogging, this.chartOptionsUsersLogging, this.chartOptionsAvgLogging].forEach(options => {
          options.xaxis.categories = shortMonths;
        });
      } catch (err) {
        console.error('Failed to fetch Google Maps API usage:', err);
      } finally {
        this.loading = false;
      }
    },

    handlePrev() {
      this.activeYear = this.activeYear - 1;
      this.fetchYear(this.activeYear);
    },
    handleNext() {
      this.activeYear = this.activeYear + 1;
      this.fetchYear(this.activeYear);
    },
  },
  computed: {
    userLabelComputed() {
      return this.userLabel || 'Example period';
    },
  },
  mounted() {
    try {
      const root = getComputedStyle(document.documentElement);
      const cssPrimary = root.getPropertyValue('--primary').trim();
      const primary = cssPrimary || "#278c64";

      // Update all color arrays
      [this.colorsTotal, this.colorsUsers, this.colorsAvg,
      this.colorsTotalSignup, this.colorsUsersSignup, this.colorsAvgSignup,
      this.colorsTotalLogging, this.colorsUsersLogging, this.colorsAvgLogging].forEach(colors => {
        colors[0] = primary;
      });

      this.primaryColor = primary;

      // Update stroke colors for all line charts
      [this.chartOptionsAvg, this.chartOptionsAvgSignup, this.chartOptionsAvgLogging].forEach(options => {
        if (options && options.stroke) {
          options.stroke.colors = [primary];
        }
      });
    } catch (e) {
      // ignore and keep fallback
    }

    this.fetchYear(this.activeYear);
  },
};
</script>

<style scoped>
.apexcharts-legend-marker {
  color: #278c64 !important;
  background: #278c64 !important;
}
</style>
